import { Flex, Link as Clink, ListItem } from '@chakra-ui/react';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import React, { useRef } from 'react';
import DropDownList from './styles';

export type DropDownMenu = {
  title: string;
  link: string;
  subMenu: { link: string; title: string; element?: string }[];
};

const DropdownMenu = ({ subMenu, title, link }: DropDownMenu) => {
  const dropdownRef = useRef<HTMLUListElement>(null);
  const { pathname } = useRouter();
  return (
    <DropDownList
      display="inline-flex"
      px={10}
      ref={dropdownRef}
      pt={7}
      borderRadius="29px"
      transition="all 0.2s ease-in-out"
    >
      <ListItem>
        <Link href={link} passHref>
          <Clink
            className="title"
            cursor="pointer"
            fontSize="lg"
            fontWeight="semibold"
          >
            {title}
          </Clink>
        </Link>
        <Flex
          className="dropdown-list"
          mt={10}
          direction="column"
          height="auto"
        >
          {subMenu.map((el, index) => (
            <Link
              key={el.link}
              href={
                pathname === el.link && el.element ? `#${el.element}` : el.link
              }
              passHref
            >
              <Clink
                className="element"
                _hover={{ textDecoration: `none` }}
                w="full"
                mb={index === subMenu.length - 1 ? 4 : 10}
              >
                {el.title}
              </Clink>
            </Link>
          ))}
        </Flex>
      </ListItem>
    </DropDownList>
  );
};

export default DropdownMenu;
